import api from './api';

const NotificationService = {
    getNotifications: () => {
        return api.get('notifications/');
    },

    markAsRead: (id) => {
        return api.post(`notifications/${id}/mark_as_read/`);
    },

    markAllAsRead: () => {
        return api.post('notifications/mark_all_as_read/');
    },

    getUnreadCount: () => {
        return api.get('notifications/unread_count/');
    }
};

export default NotificationService;
